export default __webpack_public_path__ + "static/media/opensea-logo.18c16452.png";